import React from "react";
import { fmtDateTime } from "@/lib/format";
import { Clock, FileX } from "lucide-react";

export const StorageStatus = ({ u }) => {
  if (u.file_available && u.file_expires_at) {
    return (
      <div className="mt-1 inline-flex items-center gap-1 text-[11px] text-slate-500" data-testid={`upload-file-expires-${u.id}`}>
        <Clock size={11} /> File disponibile fino al {fmtDateTime(u.file_expires_at)}
      </div>
    );
  }
  if (u.file_available) return null;
  return (
    <div
      className="mt-1 inline-flex items-center gap-1 text-[11px] text-slate-400"
      title="La copia temporanea è stata eliminata. Storico, esito e dati importati restano disponibili."
      data-testid={`upload-file-expired-${u.id}`}
    >
      <FileX size={11} /> File eliminato (conservazione temporanea scaduta)
    </div>
  );
};

export default StorageStatus;
